import SaleOptions from './SaleOptions';

export default {
  title: 'Sale Options',
  description:
    'Here you can hide buttons that you are not going to use regarding to the Sales Options.',
  path: '/pos-settings/sale-options',
  component: SaleOptions,
  rootPath: { name: 'POS Settings', uri: '/pos-settings' },
  subPath: [{ name: 'Sale Options' }],
};
